import PropTypes from "prop-types";
import classes from "./styles.module.scss";

const SunIcon = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="4.2" fill="currentColor" />
    <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <line x1="12" y1="1.5" x2="12" y2="4" />
      <line x1="12" y1="20" x2="12" y2="22.5" />
      <line x1="1.5" y1="12" x2="4" y2="12" />
      <line x1="20" y1="12" x2="22.5" y2="12" />
      <line x1="4.2" y1="4.2" x2="6" y2="6" />
      <line x1="18" y1="18" x2="19.8" y2="19.8" />
      <line x1="19.8" y1="4.2" x2="18" y2="6" />
      <line x1="6" y1="18" x2="4.2" y2="19.8" />
    </g>
  </svg>
);

const MoonIcon = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" aria-hidden="true">
    <path
      d="M20 14.5A8 8 0 0 1 9.5 4a7 7 0 1 0 10.5 10.5Z"
      fill="currentColor"
    />
  </svg>
);

/**
 * Sliding light/dark theme switch.
 * @param {"light"|"dark"} mode  current theme
 * @param {() => void} onToggle  fired on click / Enter / Space
 */
const ThemeToggle = ({ mode, onToggle }) => {
  const isDark = mode === "dark";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label="Toggle dark mode"
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className={`${classes.toggle} ${isDark ? classes.dark : ""}`}
      onClick={onToggle}
    >
      <span className={classes.icon_left}>
        <SunIcon />
      </span>
      <span className={classes.icon_right}>
        <MoonIcon />
      </span>
      <span className={classes.thumb} />
    </button>
  );
};

ThemeToggle.propTypes = {
  mode: PropTypes.oneOf(["light", "dark"]).isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default ThemeToggle;
